const resource = 'codes'

export default $axios => ({
  fetch(params) {
    return $axios.$get(`/${resource}`, { params })
  },

  fetchWelcomeOffer() {
    return $axios.$get('/v2/welcome-offer')
  },

  getServiceName: name => 'codeService',
})
